import { render, staticRenderFns } from "./template002.vue?vue&type=template&id=4a415686&scoped=true"
import script from "./template002.vue?vue&type=script&lang=js"
export * from "./template002.vue?vue&type=script&lang=js"
import style0 from "./template002.vue?vue&type=style&index=0&id=4a415686&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a415686",
  null
  
)

export default component.exports